import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";



export default function DirectoriesGrid({onClose}:{onClose: () => void}) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4">
        <NavLink to={"/data/shifts"} onClick={() => onClose()} className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary ">
            <span className="font-medium text-base">{t('shifts')}</span>
            <span className="text-sm text-muted-foreground">{t('shifts_desc')}</span>
        </NavLink>
        <NavLink to={"/data/divisions"} onClick={() => onClose()} className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary ">
            <span className="font-medium text-base">{t('divisions')}</span>
            <span className="text-sm text-muted-foreground">{t('divisions_desc')}</span>
        </NavLink>
        <NavLink to={"/data/equipment_types"} onClick={() => onClose()} className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary ">
            <span className="font-medium text-base">{t('equipment_types')}</span>
            <span className="text-sm text-muted-foreground">{t('equipment_types_desc')}</span>
        </NavLink>
        <NavLink to={"/data/manufactures"} onClick={() => onClose()} className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary ">
            <span className="font-medium text-base">{t('manufactures')}</span>
            <span className="text-sm text-muted-foreground">{t('manufactures_desc')}</span>
        </NavLink>
        <NavLink to={"/data/positions"} onClick={() => onClose()} className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary ">
            <span className="font-medium text-base">{t('positions')}</span>
            <span className="text-sm text-muted-foreground">{t('positions_desc')}</span>
        </NavLink>
    </div>
  )
} 